import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function setMyLocations(locationIds: string[]) {
  return getSMPBackendAPIAdmin().resourcesControllerSetMyLocationsV1({ locationIds });
}

export function useSetMyLocations() {
  return useMutation({
    mutationFn: setMyLocations,
  });
}
